import type { PagedAndSortedResultRequestDto } from '@abp/ng.core';
import type { OrderStatus } from '../../enums/order-status.enum';

export interface ClientOrderDetailDto {
  orderId: number;
  orderDate?: string;
  total: number;
  orderStatus?: string;
  sommelierName?: string;
  userId?: string;
  customerName?: string;
  customerEmail?: string;
  customerPhone?: string;
}

export interface ClientReportDto {
  userId?: string;
  customerName?: string;
  customerEmail?: string;
  customerPhone?: string;
  totalSpent: number;
  totalOrders: number;
  lastPurchaseDate?: string;
  orderDetails: ClientOrderDetailDto[];
}

export interface CommissionReportDto {
  sommelierId: number;
  sommelierName?: string;
  ordersCount: number;
  totalSales: number;
  totalCommission: number;
}

export interface DashboardSummaryDto {
  totalSales: SalesSummaryDto;
  newSommeliers: SommelierSummaryDto;
  inventorySummary: InventorySummaryDto;
}

export interface GetClientReportDto extends PagedAndSortedResultRequestDto {
  from?: string;
  to?: string;
  keyword?: string;
  isGrouped: boolean;
}

export interface GetCommissionPagedReportDto extends PagedAndSortedResultRequestDto {
  from?: string;
  to?: string;
  status?: OrderStatus;
  sommelierId?: number;
}

export interface GetWinesSalesReportDto extends PagedAndSortedResultRequestDto {
  from?: string;
  to?: string;
  keyword?: string;
}

export interface InventorySummaryDto {
  totalBottles: number;
}

export interface SalesSummaryDto {
  currentTotal: number;
  previousTotal: number;
  variationPercent?: number;
}

export interface SommelierSummaryDto {
  currentCount: number;
  previousCount: number;
  variationPercent?: number;
}

export interface TopWineDto {
  wineName?: string;
  region?: string;
  type?: string;
  sales: number;
  inventory: number;
}

export interface WineSalesReportDto {
  paidDate?: string;
  wineId: number;
  wineName?: string;
  totalBottles: number;
  createdAt?: string;
}
